import React, { createContext, useContext } from 'react';

// إنشاء السياق للمنصة
const PlatformContext = createContext();

// Hook لاستخدام إعدادات المنصة
export const usePlatformSettings = () => {
  const context = useContext(PlatformContext);
  return context;
};

export default PlatformContext;